import { render } from "./PdfUploadPanel.vue?vue&type=template&id=0c06ada5&scoped=true"
import script from "./PdfUploadPanel.vue?vue&type=script&lang=js"
export * from "./PdfUploadPanel.vue?vue&type=script&lang=js"

import "./PdfUploadPanel.vue?vue&type=style&index=0&id=0c06ada5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c06ada5"]])

export default __exports__